import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pollsList_template} from "../components/templates/pollsList_template";
import {vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class polls extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected referencesXHRHdl: XMLHttpRequestHandler;
    protected exportCSVxhr : XMLHttpRequestHandler;
    protected elementsList: pollsList_template;
    protected activeCommercialExportXhrs: Array<XMLHttpRequest> = [];
    protected isCommercialExportCancelled: boolean = false;
    protected commercialExportPreviousBodyOverflow = '';
    protected readonly EXPORT_CANCELLED_ERROR = 'EXPORT_CANCELLED';
    protected pollImportFile: File | null = null;
    protected pollImportXhr: XMLHttpRequest | null = null;
    protected pollImportValidationXhr: XMLHttpRequest | null = null;

    protected getModuleName(){

        return "polls";
    }


    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new pollsList_template("list", this.viewModel, this);

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Polls");

        return [this.elementsList.build()];
    }


    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public fillPage() : void{

        this.elementsList.buildDatePickerCalendar();
        let brandId = this.getBrandId();
        this.elementsList.setBrandId(brandId);
        this.elementsList.setCommercialExportDefaultDateRange();
        this.getReferences();
        this.filterList();
    }

    protected getReferences() {

        if( this.referencesXHRHdl ){
            this.referencesXHRHdl.cancelAndReset();
        }

        let usrReq_url: string = `/api/polls/references`;
        let usrReq_params: Array<Array<string>> = [];
        this.referencesXHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.referencesXHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.referencesXHRHdl.execute();
    }

    protected onReferencesRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setCommercialExportBrands(responseParsed.brands || []);
                obj.elementsList.setCommercialExportSignals(responseParsed.signalTypes || []);
                obj.elementsList.setPermissions(responseParsed.permissions || {website_user_export: {read: false}});
            });
        }
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected pollsListReorder(){

        this.filterList();
    }

    protected filterDateOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.polls;

        return templateViewModel;
    }


    protected viewPoll(itemview){

        this.saveViewModule(this.getMemoryViewModel());
        page.redirect(itemview);
    }
    //
    // protected viewPoll(id){
    //
    //     this.saveViewModule(this.getMemoryViewModel());
    //     let brandId = this.getBrandId();
    //     page(`/brand/${brandId}/categorization/polls/view/${id}`);
    // }

    protected filterList(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let brandId = this.getBrandId();
        let usrReq_url: string = `/api/brand/${brandId}/polls/get`;

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set Jobs list
        let pollsToSet = [];
        let brandId = this.getBrandId();
        for (let item of responseParsed.data) {

            let viewUrl = `/brand/${brandId}/categorization/polls/view/${item.id}`;
            pollsToSet.push({
                id: item.id,
                name: item.name,
                emakiView: viewUrl,
                dateCreated : item.dateCreated,
                dateClosed : item.dateClosed
            });
        }

        this.elementsList.setPolls(pollsToSet);
        this.elementsList.setListIsEmpty((pollsToSet.length === 0));

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    public addPoll() {
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        let brandId = this.getBrandId();

        this.saveViewModule(this.getMemoryViewModel());

        page(`/brand/${brandId}/categorization/polls/add/`);
    }

    protected exportList() {

        if (this.exportCSVxhr) {
            this.exportCSVxhr.cancelAndReset();
        }

        const viewModelData = this.elementsList.getViewModelForRequest();
        const cleanFilters = ko.toJS(viewModelData);

        let brandId = this.getBrandId();

        let url: string = `/api/brand/${brandId}/polls/export/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(cleanFilters)]);
        this.exportCSVxhr = new XMLHttpRequestHandler(url, usrReq_params, this);
        this.exportCSVxhr.mode = XMLHttpRequestHandler_requestType.POST;
        this.exportCSVxhr.onReadyStateFunction = this.onExportListReturn;
        this.exportCSVxhr.execute();
    }

    protected onExportListReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let csvContent = req.request.response;
                if (csvContent) {
                    obj.triggerCSVDownload(csvContent);
                    obj.sendNotification("CSV export done successfully");
                } else {
                    obj.sendNotification("No data to download", 'alert');
                }

                obj.elementsList.asExportInProgress(false);
                obj.elementsList.setExportTextBox("Export to CSV");
            });
        }
    }

    private sendNotification(message : string = 'Export CSV', type : 'success' | 'alert' | 'error' = 'success') {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }

    private triggerCSVDownload(csvContent: string) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');

        const today = new Date();
        const year = today.getFullYear();
        const month = ('0' + (today.getMonth() + 1)).slice(-2);
        const day = ('0' + today.getDate()).slice(-2);
        const dateStr = `${year}-${month}-${day}`;

        a.href = url;
        a.download = `Emaki Poll Data ${dateStr}.csv`;
        document.body.appendChild(a);
        a.click();

        a.remove();
        URL.revokeObjectURL(url);
    }

    public filterMultipleSelectorOnChange(idElement) {
        if (idElement == 'commercialExportBrandFilter' || idElement == 'commercialExportSignalFilter') {
            return;
        }
        this.filterList();
    }

    public showCommercialExportModal(): void {
        this.elementsList.setCommercialExportDefaultDateRange();
        this.isCommercialExportCancelled = false;
        this.elementsList.setCommercialExportCancelling(false);
        this.elementsList.setCommercialExportModalVisible(true);
        this.lockCommercialExportBackgroundScroll();
        this.elementsList.buildCommercialExportDatePickerCalendar();
    }

    public showPollImportModal(): void {
        this.resetPollImportState(false);
        this.elementsList.setPollImportModalVisible(true);
    }

    public selectPollImportFile(file: File | null): void {
        if (!file) {
            this.removePollImportFile();
            return;
        }

        const fileName = file.name || '';
        const fileType = file.type || '';
        const isCsvFile = /\.csv$/i.test(fileName) || fileType === 'text/csv';
        if (!isCsvFile) {
            this.removePollImportFile();
            this.sendNotification('Please select a CSV file.', 'alert');
            return;
        }

        this.pollImportFile = file;
        this.elementsList.setPollImportFileName(fileName);
        this.validatePollImportFile();
    }

    public removePollImportFile(): void {
        this.pollImportFile = null;
        this.abortPollImportValidationRequest();
        this.elementsList.clearPollImportFile();
    }

    public importPolls(): void {
        if (!this.pollImportFile) {
            this.sendNotification('Please select a CSV file.', 'alert');
            return;
        }

        if (!this.elementsList.isPollImportValid()) {
            this.sendNotification('Please upload a valid CSV file.', 'alert');
            return;
        }

        if (this.pollImportXhr) {
            this.pollImportXhr.abort();
        }

        const brandId = this.getBrandId();
        const formData = new FormData();
        formData.append('csvFile', this.pollImportFile);
        formData.append('generateCommercialSignals', this.elementsList.getPollImportGenerateCommercialSignals() ? '1' : '0');

        const xhr = new XMLHttpRequest();
        this.pollImportXhr = xhr;
        xhr.open('POST', `/api/brand/${brandId}/polls/import/`, true);
        xhr.responseType = 'json';

        xhr.onload = () => {
            this.pollImportXhr = null;
            this.elementsList.setPollImportInProgress(false);

            if (xhr.status === 200) {
                this.resetPollImportState(true);
                this.filterList();
                this.sendNotification('Polls import completed successfully');
                return;
            }

            const response = xhr.response || {};
            this.sendNotification(this.getValidationMessages(response, 'Failed to import polls.').join(' '), 'error');
        };

        xhr.onerror = () => {
            this.pollImportXhr = null;
            this.elementsList.setPollImportInProgress(false);
            this.sendNotification('Failed to import polls.', 'error');
        };

        xhr.onabort = () => {
            this.pollImportXhr = null;
            this.elementsList.setPollImportInProgress(false);
        };

        this.elementsList.setPollImportInProgress(true);
        xhr.send(formData);
    }

    public cancelPollImport(): void {
        this.abortPollImportValidationRequest();
        if (this.pollImportXhr) {
            this.pollImportXhr.abort();
        }

        this.resetPollImportState(true);
    }

    private validatePollImportFile(): void {
        if (!this.pollImportFile) {
            this.elementsList.setPollImportValidationState(false, false);
            return;
        }

        this.abortPollImportValidationRequest();
        this.elementsList.setPollImportValidationState(true, false);

        const brandId = this.getBrandId();
        const formData = new FormData();
        formData.append('csvFile', this.pollImportFile);

        const xhr = new XMLHttpRequest();
        const validationFile = this.pollImportFile;
        this.pollImportValidationXhr = xhr;
        xhr.open('POST', `/api/brand/${brandId}/polls/import/validate/`, true);
        xhr.responseType = 'json';

        xhr.onload = () => {
            if (this.pollImportValidationXhr !== xhr || this.pollImportFile !== validationFile) {
                return;
            }
            this.pollImportValidationXhr = null;

            if (xhr.status === 200) {
                this.elementsList.setPollImportValidationState(false, true);
                return;
            }

            const response = xhr.response || {};
            this.elementsList.setPollImportValidationState(false, false, this.getValidationMessages(response));
        };

        xhr.onerror = () => {
            if (this.pollImportValidationXhr !== xhr || this.pollImportFile !== validationFile) {
                return;
            }
            this.pollImportValidationXhr = null;
            this.elementsList.setPollImportValidationState(false, false, ['Failed to validate CSV file.']);
        };

        xhr.onabort = () => {
            if (this.pollImportValidationXhr !== xhr) {
                return;
            }
            this.pollImportValidationXhr = null;
        };

        xhr.send(formData);
    }

    public exportCommercialData(): void {
        const brandId = Number(this.getBrandId());
        const baseRequestData = ko.toJS(this.elementsList.getCommercialExportViewModelForRequest());
        const exportPageSize = 100000;

        this.isCommercialExportCancelled = false;
        this.elementsList.setCommercialExportCancelling(false);

        const onError = (message: string) => {
            this.resetCommercialExportState();
            this.sendNotification(message, 'alert');
        };

        const runExport = async () => {
            try {
                this.elementsList.setCommercialExportState(true, 'Preparing export...');

                let allRows = [];
                let offset = 0;
                let batchNumber = 0;

                while (true) {
                    if (this.isCommercialExportCancelled) {
                        throw new Error(this.EXPORT_CANCELLED_ERROR);
                    }

                    batchNumber++;
                    this.elementsList.setCommercialExportState(true, 'Loading batch ' + batchNumber + ' (offset ' + offset + ')...');

                    const batch = await this.fetchCommercialExportBatch(brandId, baseRequestData, offset, exportPageSize);

                    if (this.isCommercialExportCancelled) {
                        throw new Error(this.EXPORT_CANCELLED_ERROR);
                    }

                    allRows = allRows.concat(batch);

                    if (batch.length < exportPageSize) {
                        break;
                    }

                    offset += exportPageSize;
                }

                this.elementsList.setCommercialExportState(true, 'Generating CSV...');
                const csv = this.buildCommercialExportCsv(allRows);
                const exportDate = new Date().toISOString().slice(0, 10);
                this.downloadCsv(csv, `Poll Commercial Data ${exportDate}.csv`);
                this.resetCommercialExportState();
                this.sendNotification("CSV export done successfully");
            } catch (error) {
                const exportError: any = error;
                if (exportError && exportError.message === this.EXPORT_CANCELLED_ERROR) {
                    this.resetCommercialExportState();
                    return;
                }
                onError('Failed to export poll commercial data.');
            }
        };

        runExport();
    }

    private fetchCommercialExportBatch(idBrand: number, baseRequestData: any, offset: number, limit: number): Promise<any[]> {
        return new Promise((resolve, reject) => {
            const requestData = JSON.parse(JSON.stringify(baseRequestData || {}));
            requestData.limit = limit;
            requestData.offset = offset;

            let xhr = new XMLHttpRequest();
            this.trackCommercialExportXhr(xhr);
            xhr.open('POST', '/api/brand/' + idBrand + '/polls/commercial-data/export-csv/', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.responseType = 'json';

            xhr.onload = () => {
                this.untrackCommercialExportXhr(xhr);
                if (xhr.status !== 200) {
                    reject(new Error('Export request failed with status ' + xhr.status));
                    return;
                }

                try {
                    let response = xhr.response;
                    if (!response && xhr.responseText) {
                        response = JSON.parse(xhr.responseText);
                    }

                    const paginatedResults = (response && response.paginatedResults) ? response.paginatedResults : {};
                    const pageData = paginatedResults.data || [];
                    const rows = Array.isArray(pageData.commercialData) ? pageData.commercialData : (Array.isArray(pageData) ? pageData : []);

                    resolve(rows);
                } catch (error) {
                    reject(new Error('Failed to parse export response.'));
                }
            };

            xhr.onerror = () => {
                this.untrackCommercialExportXhr(xhr);
                if (this.isCommercialExportCancelled) {
                    reject(new Error(this.EXPORT_CANCELLED_ERROR));
                    return;
                }
                reject(new Error('Export request network error.'));
            };

            xhr.onabort = () => {
                this.untrackCommercialExportXhr(xhr);
                reject(new Error(this.EXPORT_CANCELLED_ERROR));
            };

            xhr.send(JSON.stringify({ data: requestData }));
        });
    }

    public cancelCommercialExport(): void {
        if (!this.elementsList.getTemplateViewModel().commercialExportInProgress()) {
            this.elementsList.setCommercialExportModalVisible(false);
            this.unlockCommercialExportBackgroundScroll();
            return;
        }
        this.isCommercialExportCancelled = true;
        this.elementsList.setCommercialExportCancelling(true);
        this.elementsList.setCommercialExportState(true, 'Cancelling export...');
        this.abortActiveCommercialExportXhrs();
    }

    private trackCommercialExportXhr(xhr: XMLHttpRequest): void {
        this.activeCommercialExportXhrs.push(xhr);
    }

    private untrackCommercialExportXhr(xhr: XMLHttpRequest): void {
        this.activeCommercialExportXhrs = this.activeCommercialExportXhrs.filter((activeXhr) => activeXhr !== xhr);
    }

    private abortActiveCommercialExportXhrs(): void {
        for (const xhr of this.activeCommercialExportXhrs) {
            try {
                xhr.abort();
            } catch (error) {
                // no-op
            }
        }
        this.activeCommercialExportXhrs = [];
    }

    private resetCommercialExportState(): void {
        this.isCommercialExportCancelled = false;
        this.abortActiveCommercialExportXhrs();
        this.elementsList.setCommercialExportState(false, '');
        this.elementsList.setCommercialExportCancelling(false);
        this.elementsList.setCommercialExportModalVisible(false);
        this.unlockCommercialExportBackgroundScroll();
    }

    private lockCommercialExportBackgroundScroll(): void {
        this.commercialExportPreviousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }

    private unlockCommercialExportBackgroundScroll(): void {
        document.body.style.overflow = this.commercialExportPreviousBodyOverflow;
    }

    private resetPollImportState(closeModal: boolean): void {
        this.abortPollImportValidationRequest();
        this.pollImportFile = null;
        this.elementsList.resetPollImportForm();

        if (closeModal) {
            this.elementsList.setPollImportModalVisible(false);
        }
    }

    private abortPollImportValidationRequest(): void {
        if (!this.pollImportValidationXhr) {
            return;
        }

        this.pollImportValidationXhr.abort();
        this.pollImportValidationXhr = null;
    }

    private getValidationMessages(response: any, fallbackMessage: string = 'CSV file validation failed.'): Array<string> {
        const validations = response && response.validations ? response.validations : [];
        let messages = [];

        if (response && response.message) {
            messages.push(response.message);
        }

        for (const validation of validations) {
            if (validation && validation.messages) {
                messages = messages.concat(validation.messages);
            }
        }

        return messages.length ? messages : [fallbackMessage];
    }

    private buildCommercialExportCsv(rows: any[]): string {
        const headers = [
            'Email address',
            'Website access point user ID',
            'Brand ID',
            'Poll ID',
            'Poll question ID',
            'Poll question text',
            'Poll response ID',
            'Poll response text',
            'Commercial signal',
            'Commercial entity',
            'Commercial value',
            'Response date'
        ];
        const csvRows = rows.map((row) => [
            row.emailAddress || '',
            row.websiteAccessPointUserId || '',
            row.brandId || '',
            row.pollId || '',
            row.pollQuestionId || '',
            row.pollQuestionText || '',
            row.pollResponseId || '',
            row.pollResponseText || '',
            row.commercialSignal || '',
            row.commercialEntity || '',
            row.commercialValue || '',
            row.responseDate || ''
        ]);

        return [headers, ...csvRows]
            .map((row) => row.map((cell) => this.escapeCsvCell(cell)).join(','))
            .join('\r\n');
    }

    private escapeCsvCell(value: any): string {
        const strValue = value === null || value === undefined ? '' : String(value);
        if (/[",\n\r]/.test(strValue)) {
            return '"' + strValue.replace(/"/g, '""') + '"';
        }
        return strValue;
    }

    private downloadCsv(csv: string, fileName: string): void {
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }
}



// WEBPACK FOOTER //
// ./js/modules/polls.ts